import { Action } from '@ngrx/store';
import { LandLineProcedureInterface } from '../../models/land-line-procedure.interface';

export enum ELandLineProceduresActions {
  GetLandLineProcedures = '[LANDLINE_PROCEDURES] Get Land Line procedures',
  GetLandLineProceduresSuccess = '[LANDLINE_PROCEDURES] Get Land Line procedures success',
  GetLandLineProceduresFailure = '[LANDLINE_PROCEDURES] Get Land Line procedures failure'
}

export class GetLandLineProcedures implements Action {
  public readonly type = ELandLineProceduresActions.GetLandLineProcedures;
  constructor(public landline: string) {}
}

export class GetLandLineProceduresSuccess implements Action {
  public readonly type = ELandLineProceduresActions.GetLandLineProceduresSuccess;
  constructor(public payload: Array<LandLineProcedureInterface>) {}
}

export class GetLandLineProceduresFailure implements Action {
  public readonly type = ELandLineProceduresActions.GetLandLineProceduresFailure;
}

export type LandLineProceduresActions = GetLandLineProcedures | GetLandLineProceduresSuccess | GetLandLineProceduresFailure;
